import React from 'react'
import PropTypes from 'prop-types'

const Loading = (props) => {
  const { size } = props

  if (props.model === 'secondary') {
    return (
      <svg
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <g
          fill="none"
          fillRule="evenodd"
        >
          <path
            fill="#00632f"
            d="M234.667 85.333h42.667v-85.333h-42.667zM146.667 23.666l-37.167 21.333 42.667 73.833 37-21.334z"
          />
          <path
            fill="#26975c"
            d="M118.834 152.167l-73.833-42.667-21.334 37.167 73.833 42.667zM0 277.333h85.333v-42.667h-85.333zM23.666 365.666l21.334 36.834 73.833-42.667-21.334-37zM146.5 488.333l42.667-73.833-37-21.334-42.667 73.833z"
          />
          <path
            fill="#008645"
            d="M234.667 426.666v85.333h42.667v-85.333zM365.5 488.333l37-21.334-42.667-73.833-37 21.334zM393.166 360l74 42.5 21.166-37-73.833-42.5zM426.667 234.667v42.667h85.333v-42.667z"
          />
          <path
            fill="#00632f"
            d="M467 109.499l-73.833 42.667 21.334 37 73.833-42.5zM402.5 44.999l-37-21.334-42.5 73.833 36.834 21.334z"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="0 256 256;30 256 256;60 256 256;90 256 256;120 256 256;150 256 256;180 256 256;210 256 256;240 256 256;270 256 256;300 256 256;330 256 256;"
            dur={props.duration}
            repeatCount="indefinite"
            calcMode="discrete"
          />
        </g>
      </svg>
    )
  }
  // By Sam Herbert (@sherb), for everyone. More @ http://goo.gl/7AJzbL
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 38 38"
      xmlns="http://www.w3.org/2000/svg"
      stroke={props.color}
    >
      <g
        fill="none"
        fillRule="evenodd"
      >
        <g
          transform="translate(1 1)"
          strokeWidth="2"
        >
          <circle
            strokeOpacity={props.outerOpacity}
            cx="18"
            cy="18"
            r="18"
          />
          <path
            d="M36 18c0-9.94-8.06-18-18-18"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur={props.duration}
              repeatCount="indefinite"
            />
          </path>
        </g>
      </g>
    </svg>
  )
}

Loading.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  outerOpacity: PropTypes.number,
  duration: PropTypes.string,
  model: PropTypes.string,
}

Loading.defaultProps = {
  color: '#00b05a',
  size: 38,
  outerOpacity: 0.5,
  duration: '.6s',
  model: '',
}

export default Loading



// WEBPACK FOOTER //
// ./src/shared/components/loading/index.js